import { EMPTY_ARRAY, EMPTY_OBJECT } from '@/redux/selectors/pieveSelectors/constants.js';

export const triggerAppActionsByAppRef = (state) => state?.pieve?.triggerAppActionsByAppRef || EMPTY_OBJECT;
export const triggerAppActionErrorsByAppRef = (state) => state?.pieve?.triggerAppActionErrorsByAppRef || EMPTY_OBJECT;
export const triggerAppActionsLoadedByAppRef = (state) => state?.pieve?.triggerAppActionsLoadedByAppRef || EMPTY_OBJECT;

export const triggerAppActions = (state, appRef) => {
  const normalizedAppRef = String(appRef || '').trim();

  if (!normalizedAppRef) {
    return EMPTY_ARRAY;
  }

  return triggerAppActionsByAppRef(state)?.[normalizedAppRef] || EMPTY_ARRAY;
};

export const triggerAppActionsError = (state, appRef) => {
  const normalizedAppRef = String(appRef || '').trim();

  if (!normalizedAppRef) {
    return '';
  }

  return String(triggerAppActionErrorsByAppRef(state)?.[normalizedAppRef] || '');
};

export const hasTriggerAppActionsLoaded = (state, appRef) => {
  const normalizedAppRef = String(appRef || '').trim();

  if (!normalizedAppRef) {
    return false;
  }

  return triggerAppActionsLoadedByAppRef(state)?.[normalizedAppRef] === true;
};
